import { render, staticRenderFns } from "./NoteUpgrades.vue?vue&type=template&id=f4967eb0&"
import script from "./NoteUpgrades.vue?vue&type=script&lang=js&"
export * from "./NoteUpgrades.vue?vue&type=script&lang=js&"
import style0 from "./NoteUpgrades.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports